module.exports = __webpack_public_path__ + "static/media/life_underwater.d26f4529.png";